module.exports = __webpack_public_path__ + "static/blog_machine_learning-72727c766541fb28ce1348f10a16617d.jpg";